export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.19-1207.23",
  commitId: "fe3307374300c0f7c3500890b377cf5f251d3e05",
  commitTime: "2026-08-19T12:07:23.000Z",
});
